<template>
  <div>
    <Breadcrumbs></Breadcrumbs>
    <div v-if="selectedProduct" class="product-details">
      <div class="w-100 product-border card mb-3">
         <div class="row px-0 pt-0 pt-lg-3 px-lg-5 no-gutters product-panel">
          <div class="col-lg-6 images pt-sm-4">
            <img
              class="card-img d-flex ml-auto mr-auto mb-3 mb-sm-0"
              :class="{'selected-product-image': selectedProduct.product.images.length > 1}"
              :src="productImageUrl"
              @error="setAltImg($event)"
              alt=""
            />
            <div v-if="onSale" class="new-onsale">Sale</div>
            <div v-if="selectedProduct.product && selectedProduct.product.images && selectedProduct.product.images.length" class="related-products px-5">
              <carousel
              ref="relatedProductsCarousel"
              :per-page-custom="[[0,3], [768,6], [992, 5]]"
              class="item-status-carousel nav-icon nav-enabled"
              :scroll-per-page="false"
              :centerMode="true"
              :pagination-enabled="false"
              :navigation-enabled="true"
              navigation-prev-label='<span class="carousel-control-prev-icon prev"></span>'
              navigation-next-label='<span class="carousel-control-next-icon"></span>'
              >
              <slide class="" v-for="image in selectedProduct.product.images" :key="image.id">
                  <b-link class="thumbnail" @click="selectProductImage(image)">
                      <img :src="image.file.original" alt="" class="p-0" />
                  </b-link>
                  </slide>
              </carousel>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="px-sm-0 px-md-3 card-body d-flex flex-column h-100">
              <h2 class="detail-product-name">{{selectedProduct.name}}</h2>
               <div class="align-items-center d-sm-flex justify-content-between mt-1">
                <div class="flex-sm-row flex-column flex-basis justify-content-around price mb-sm-0 mb-0">
                  <template v-if="hasRelatedDiscount">
                    <div class="price-left product-details-price d-flex align-items-center">
                      <span class="original-price pr-2">{{selectedProduct.price | currency(selectedProduct.currency)}}</span>
                      <span class="sale-price">{{selectedRelatedProduct.price | currency(selectedProduct.currency)}}</span>
                    </div>
                  </template>
                  <template v-else-if="onSale || hasMemberDiscount">
                    <div class="price-left product-details-price d-flex align-items-center">
                      <span v-if="onSale">
                        <span class="original-price pr-2">
                        {{selectedProduct.product.msrp | currency(selectedProduct.currency)}}
                        </span>
                      </span>
                      <span class="d-flex flex-column" :class="hasMemberDiscount && session.has_membership ? 'original-price' : 'sale-price'">
                        <span><span :class="!onSale ? 'font-weight-normal': ''">{{selectedProduct.price | currency(selectedProduct.currency)}}</span> </span>
                        <span class="member font-weight-500" v-if="!onSale">Regular Price</span>
                      </span>
                      <div class="d-flex" v-if="hasMemberDiscount">
                        <div class="font-weight-normal vertical-line px-2">|</div>
                        <div class="sale-price d-flex flex-column">
                          <span class="font-weight-normal">{{selectedProduct.membership_price | currency(selectedProduct.currency)}}</span> <span class="member font-weight-500">Member Price</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="price-color font-weight-normal">{{selectedProduct.price | currency(selectedProduct.currency)}}</div>
                  </template>
                </div>
              </div>
              <div class="status mt-4" v-html="selectedProduct.product.description"></div>
              <div class="quantity-toggle my-2 flex-column">
                <div class="quantity mb-2">QTY</div>
                <div class="cart-quantity-wrapper">
                  <button class="cart-quantity-button" :disabled="productQuantity === 1" @click="updateQuantity(productQuantity-1)">&mdash;</button>
                  <input class="cart-quantity-input border" step="1" type="number" min="1" :max="selectedProduct.max_quantity || 10"
                         v-model.number="productQuantity" v-on:input="updateQuantity(+$event.currentTarget.value)" />
                  <button class="cart-quantity-button" :disabled="productQuantity === selectedProduct.max_quantity"  @click="updateQuantity(productQuantity+1)">&#xff0b;</button>
                </div>
                <p v-if="productQuantity === selectedProduct.max_quantity" class="max-quantity">
                  <sup>*</sup>Maximum order limit of {{selectedProduct.max_quantity}}
                </p>
              </div>
              <div v-if="productVariants.length" class="mt-4">
                <VariantSelector
                  :variants="productVariants"
                  :quantity="productQuantity"
                  :bundle-quantity="bundleQuantity"
                  @change="onVariantSelectionChange"
                ></VariantSelector>
              </div>
              <div class="d-flex flex-row align-items-left product-detail-btn mt-3">
                <template v-if="!canBuyProduct">
                  <b-button
                    v-if="selectedProduct.url"
                    class="buy-now-button text-uppercase mb-0 mr-sm-0"
                    variant="primary"
                    :href="selectedProduct.url"
                    target="_blank"
                  >
                    BUY NOW
                  </b-button>
                </template>
                <template v-else>
                  <b-button
                    class="buy-now-button add-to-cart text-uppercase ml-0 mb-0 mr-sm-0 text-nowrap stroke-2x"
                    variant="outline-success"
                    :disabled="isAddToCartDisabled"
                    @click="addToCart(false)"
                  >
                    Add to Cart
                  </b-button>
                  <b-button
                    class="buy-now-button text-uppercase ml-2 mb-0 mr-sm-0"
                    variant="primary"
                    :disabled="isAddToCartDisabled"
                    @click="addToCart(true)"
                  >
                    BUY NOW
                  </b-button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-tabs v-if="selectedProduct.product && selectedProduct.product.info && selectedProduct.product.info.length"
              class="prod-detail-tabs product-border card w-100 mt-5" content-class="mt-3" justified>
        <b-tab
          v-for="(info, index) in selectedProduct.product.info"
          :key="index"
          :title="info.section"
        >
          <div class="product-info-content" v-html="info.content"></div>
        </b-tab>
      </b-tabs>
      <div v-if="selectedProduct.related_products && selectedProduct.related_products.length" class="related-products">
        <div class="title centered-block mt-4 mb-5">You might also like...</div>
        <carousel
          ref="relatedProductsCarousel"
          class="item-status-carousel"
          :class="{'nav-enabled': isRelatedProductsNavEnabled}"
          :per-page-custom="[[0,1], [768,2], [992,4]]"
          :scroll-per-page="false"
          :pagination-enabled="false"
          :navigation-enabled="true"
          navigation-prev-label='<span class="carousel-control-prev-icon"></span>'
          navigation-next-label='<span class="carousel-control-next-icon"></span>'
        >
          <slide v-for="related_product in relatedTileProducts" :key="related_product.id">
            <RelatedProductTile :product="related_product" :session="session"></RelatedProductTile>
          </slide>
        </carousel>
      </div>
      <CheckoutCustomerConfirmation
        v-if="showVerificationPopup"
        @close="closePopUp"
        v-on:verified="customerVerified"
        @verificationFailed="customerVerificationFailed"
        :session="session"
      ></CheckoutCustomerConfirmation>
      <b-row v-if="session && session.can_undo" class="justify-content-center boxes select-item-btn customer-verify mt-4">
        <b-col md="4" lg="3" cols="8">
          <button type="button" @click="goBack()" class="btn-base input-choice-btn new-btn-outline-success stroke-2x">Back</button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapState, mapGetters } from 'vuex'
import {getPlaceholderImageUrl, stopMouseflowRecording} from '@/utils'
import Breadcrumbs from './Breadcrumbs'
import RelatedProductTile from './RelatedProductTile'
import VariantSelector from './VariantSelector'
const CheckoutCustomerConfirmation = () => import('../components/CheckoutCustomerConfirmation')

export default {
  name: 'ProductDetails',
  components: {Breadcrumbs, RelatedProductTile, Carousel, Slide, CheckoutCustomerConfirmation, VariantSelector},
  props: {
    relatedProduct: Object
  },
  data: function() {
    return {
      productQuantity: 1,
      productImage: null,
      relatedProductSlide: 0,
      screenWidth: 0,
      isRelatedProductsNavEnabled: false,
      productVariants: [],
      selectedVariants: [],
      variantSelectionComplete: false,
      bundleQuantity: 1,
      showVerificationPopup: false,
      productId: null,
      selectedProduct: null
    }
  },
  metaInfo: function() {
    let description = 'Product Details'
    let keywords = null
    let metaInfo = {
      title: this.selectedProduct ? this.selectedProduct.name : 'Product Details',
      meta: []
    }
    if (this.selectedProduct) {
      description = this.selectedProduct.meta_description || this.selectedProduct.product.description || 'Product Details'
      keywords = this.selectedProduct.keywords
      const descriptionEl = document.createElement('div')
      descriptionEl.innerHTML = description
      description = descriptionEl.textContent || descriptionEl.innerText
      metaInfo.meta.push({name: 'description', content: description})
      metaInfo.meta.push({name: 'keywords', content: keywords || metaInfo.title})
    }
    return metaInfo
  },
  computed: {
    ...mapState(['session', 'campaign']),
    ...mapGetters(['canLogoutSession', 'isSessionUserKnown', 'checkoutDisabled']),
    isCustomerPortalSession: function() {
      return !!this.session && this.session.type === 4 // SessionType.CustomerPortal
    },
    relatedTileProducts: function() {
      // related products render once per target product, with the display name override and marketplace price applied;
      // customer portal sessions get no related pricing until the portal display ships
      const relatedProducts = (this.selectedProduct && this.selectedProduct.related_products) || []
      const withPricing = !this.isCustomerPortalSession

      return relatedProducts
        .filter((rp, index) => relatedProducts.findIndex(other => other.to_campaign_product.id === rp.to_campaign_product.id) === index)
        .map(rp => Object.assign({}, rp.to_campaign_product, {
          name: rp.display_name || rp.to_campaign_product.name,
          related_product: withPricing ? {
            id: rp.id,
            price: rp.price,
            discount_percent: rp.marketplace_discount_percent,
            to_campaign_product: rp.to_campaign_product.id,
            to_variant: rp.to_variant ? rp.to_variant.id : null
          } : undefined
        }))
    },
    applicableRelatedProduct: function() {
      // a related product tile carries its marketplace price into the details page of its target product
      if (!this.isCustomerPortalSession && this.relatedProduct && this.selectedProduct &&
        this.relatedProduct.to_campaign_product === this.selectedProduct.id) {
        return this.relatedProduct
      }

      return null
    },
    selectedRelatedProduct: function() {
      // a variant-specific related product only applies once that variant is selected
      const relatedProduct = this.applicableRelatedProduct

      if (!relatedProduct || relatedProduct.to_variant == null) {
        return relatedProduct
      }

      const isBundled = this.selectedProduct.product.variant_type === 2 // VariantType.Bundled
      const variant = !isBundled && this.selectedVariants.length > 0 ? this.selectedVariants[0].variant : null

      return variant && variant.id === relatedProduct.to_variant ? relatedProduct : null
    },
    hasRelatedDiscount: function() {
      return !!this.selectedRelatedProduct && this.selectedRelatedProduct.price != null &&
        parseFloat(this.selectedRelatedProduct.discount_percent) > 0
    },
    productImageUrl: function() {
      if (this.productImage) {
        return this.productImage.file.original
      }

      return getPlaceholderImageUrl('original')
    },
    isThumbnailCarouselEnabled: function() {
      return window.innerWidth <= 768
    },
    onSale: function() {
      return this.selectedProduct.product.msrp &&
        ((parseFloat(this.selectedProduct.product.msrp) - parseFloat(this.selectedProduct.price)) > Number.EPSILON)
    },
    hasMemberDiscount: function() {
      return this.selectedProduct.membership_price !== null &&
        ((parseFloat(this.selectedProduct.price) - parseFloat(this.selectedProduct.membership_price)) > Number.EPSILON)
    },
    canBuyProduct: function() {
      return this.campaign.portal_settings &&
        this.campaign.portal_settings.allow_buy_again &&
        this.selectedProduct.can_charge_customer &&
        !this.checkoutDisabled
    },
    isAddToCartDisabled: function() {
      // Disable if product has variants but selection is not complete
      return this.productVariants.length > 0 && !this.variantSelectionComplete
    }
  },
  methods: {
    setAltImg: function(event) {
      event.target.src = getPlaceholderImageUrl('original')
    },
    init: function(productId) {
      this.productQuantity = 1
      if (productId) {
        if (!this.session) {
          this.$store.dispatch('start')
            .then(_ => {
              this.init(productId)
            })
        } else {
          this.$store.commit('busy')
          this.$store.dispatch('get_product', {id: productId})
            .then(result => {
              this.$store.commit('ready')
              this.setProduct(result.data)
            })
            .catch(err => {
              console.log(err)
              this.$store.commit('ready')
              this.$router.replace({name: 'session'})
            })
        }
      } else {
        this.$router.replace({name: 'session'}) // ignore the jump and stay where we are in the session
      }
    },
    selectProductImage: function(image) {
      this.productImage = image
    },
    onResize(event) {
      if (this.selectedProduct && this.selectedProduct.related_products.length) {
        this.isRelatedProductsNavEnabled = this.$refs.relatedProductsCarousel.isNavigationRequired
      }
    },
    goBack: function() {
      this.$router.go(-1)
    },
    updateQuantity(quantity) {
      if (quantity > 0) {
        if (quantity <= this.selectedProduct.max_quantity) {
          this.productQuantity = parseInt(quantity)
        } else {
          this.productQuantity = this.selectedProduct.max_quantity
        }
      } else {
        this.productQuantity = 1
      }
    },
    addToCart(checkout) {
      // Validate variant selection if variants exist
      if (this.productVariants.length > 0 && !this.variantSelectionComplete) {
        this.$store.commit('error', 'Please select all variant options')
        return
      }

      let item = {
        campaign_product: this.selectedProduct,
        variant: null,
        quantity: this.productQuantity,
        bundled_variants: null
      }

      if (this.selectedVariants.length > 0) {
        // Check if this is a bundled variant product
        const isBundled = this.selectedProduct.product.variant_type === 2 // VariantType.Bundled

        if (isBundled) {
          // For bundled variants, VariantSelector already provides {variant, quantity} format
          item.bundled_variants = this.selectedVariants
        } else {
          // For standard variants, use single variant (take the first one)
          // VariantSelector provides {variant, quantity} format
          item.variant = this.selectedVariants[0].variant
        }
      }

      if (this.selectedRelatedProduct) {
        item.related_product = this.selectedRelatedProduct
      }

      this.$store.commit('busy')
      this.$store.dispatch('set_session_started')
      this.$store.dispatch('add_cart', item)
        .then(() => {
          this.$store.commit('ready')
          if (checkout) {
            if (this.isSessionUserKnown) {
              this.customerVerified()
            } else {
              this.showVerificationPopup = true
            }
          } else {
            this.$store.commit('set_cart_state', true)
            setTimeout(() => {
              this.$store.commit('set_cart_state', false)
            }, 6000)
          }
        })
        .catch(err => {
          let errorMessage = ''
          if (err.response && err.response.status === 400) {
            errorMessage = err.response.data['items']
          }
          this.$store.commit('error', errorMessage || err)
          this.$store.commit('ready')
        })
    },
    onVariantSelectionChange({ isComplete, selectedVariants }) {
      this.variantSelectionComplete = isComplete
      this.selectedVariants = selectedVariants
    },
    customerVerified: function() {
      this.showVerificationPopup = false
      this.$router.push({name: 'session-jump', params: {step: 'checkout'}})
    },
    customerVerificationFailed: function(message) {
      this.$store.commit('error', message)
      this.$router.push({name: 'session-jump', params: {step: 'checkout'}})
    },
    closePopUp: function() {
      this.showVerificationPopup = false
    },
    setProduct: function(product) {
      this.selectedProduct = product
      this.productImage = this.selectedProduct.product.images.length ? this.selectedProduct.product.images[0]
        : this.selectedProduct.product.default_image

      // Reset variant state
      this.selectedVariants = []
      this.variantSelectionComplete = false

      // Set bundle quantity (for bundled variant products)
      this.bundleQuantity = this.selectedProduct.bundle_quantity || 1

      // Set variants for VariantSelector component
      if (this.selectedProduct.show_variants && this.selectedProduct.product.variants) {
        this.productVariants = this.selectedProduct.product.variants
      } else {
        this.productVariants = []
      }
    }
  },
  created() {
    this.init(this.$route.params.id)
    stopMouseflowRecording()
  },
  beforeRouteUpdate(to, from, next) {
    this.init(to.params.id)
    next()
  },
  mounted() {
    window.addEventListener('resize', this.onResize)

    if (this.selectedProduct && this.selectedProduct.related_products.length) {
      this.isRelatedProductsNavEnabled = this.$refs.relatedProductsCarousel.isNavigationRequired
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped lang="less">
  .price-left {
    float: left;
    .original-price {
      color: var(--sale_original_price_color);
    }
  }

  .product-detail-btn {
    button, a {
      font-size: 20px;
      height: 50px !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .product-detail {
    float: left;
    padding-left: 20px;
    h5 {
      color: var(--text_color);
      font-size: 16px;
      font-weight: 600;
      margin: 0;
    }
    ul {
      margin: 25px 0 0 0;
      padding: 0;
      list-style-type: none;
      li {
        color: var(--text_color);
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .product-info-content {
    padding: 10px 20px;
  }

  .product-panel {
    -webkit-box-shadow: 0 0 13px -8px var(00);
    box-shadow: 0 0 13px -8px var(--text_color);
    border-radius: 6px;
    padding: 1.5rem 0;
    background-color: var(--content_background_color);;

    .VueCarousel-slide {
      margin-bottom: 10px;
      display: inline-block;
    }

    .img-slide {
      box-shadow: 0 0 13px -9px #333;
      border-radius: 6px;
      background-color: #ffffff;
      margin-left: 20px;
    }

    .product-carousel {
      height: 100%;
      overflow: auto;
    }

    .right-img {
      height: 100%;
      img {
        width: 100% !important;
        padding: 0 !important;
        object-fit: contain;
      }
    }

    .img-sm {
      padding: 20px 40px;
    }

    .quantity-toggle {
      display: flex;
      .cart-quantity-wrapper {
        display: inline-flex;
        align-items: stretch;
        height: 42px;
        width: fit-content;
        border-radius: 4px;
        overflow: hidden;
      }
      .cart-quantity-input {
        border: 1px solid #ddd;
        width: 53px;
        text-align: center;
        border-left-width: 0 !important;
        border-right-width: 0 !important;
        border-radius: 0;
        -moz-appearance: textfield;
        appearance: textfield;
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
      .cart-quantity-button {
        border: 1px solid #ddd;
        background: #f5f5f5;
        font-size: 1rem;
        line-height: 1;
        min-width: 42px;
        padding: 0;
        cursor: pointer;
        &:disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
      }
      .quantity {
        font-size: 14px;
      }
    }
    .price {
      color: var(--theme_color);
      font-size: 30px;
    }
  }

  @media (max-width: 992px) {
    .product-panel {
      box-shadow: none;
      .right-img {
        height: 300px;
      }
      .product-carousel {
        height: 300px;
        img {
          height: 87px;
        }
      }
      .card-body {
        padding: 1.25rem 0.2rem;
      }
    }
  }

  @media (max-width:768px) {
    .product-panel {
      .VueCarousel-inner {
        margin-left: 0;
      }

      .card-body {
        padding-top: 0.5rem;
      }
    }

    .product-detail {
      padding-top: 25px;
    }
  }
</style>
